$(document).ready(function () {
    $(".tpl-product-category #product-filters").on("change", function (e) {
        let filters = {};

        $(".tpl-product-category #product-filters input:checked").each(
            function (index, input) {
                const propertyId = $(input).data("property");
                const propertyValueId = $(input).data("value");

                if (!filters[propertyId]) filters[propertyId] = [];

                filters[propertyId].push(propertyValueId);
            }
        );

        console.log(filters);

        $(".tpl-product-category .product-display").each(function (
            index,
            product
        ) {
            let show = true;
            const properties = $(product).data("properties");
            for (let filterId of Object.keys(filters)) {
                if (
                    !properties[filterId] ||
                    !properties[filterId].some((value) =>
                        filters[filterId].includes(value)
                    )
                ) {
                    show = false;
                    break;
                }
            }

            if (show) $(product).fadeIn();
            else $(product).fadeOut();
        });       
    });

    $(".tpl-product-category #product-filters .form-check").on(
        "click",
        function (e) {
            const input = $(this).find("input");
            input.trigger("change");
        }
    );

    if ($(window).width() < 768)
        $(".tpl-product-category .accordion-collapse").removeClass("show");

    $(".tpl-product-category #product-filters").change();
});
